import { useParams } from "react-router-dom";
import { usePeriods, useReport } from "./link-report-queries";
import { useLinkWindow, usePeriod, useReportRange } from "./link-store";
import { defaultMetric, reportMetrics } from "./link-metrics";

export function useLinkReport(report, id, api) {
    const { accountID, showID } = useParams();

    const { start, end } = useReportRange();
    const period = usePeriod();
    const linkWindow = useLinkWindow();

    // TODO: filters
    const filters = [];

    // TODO: metric selection
    const metric = defaultMetric(report).value;
    const metricLabel = defaultMetric(report).label;

    // TODO: report-specific labels
    const labels = { total: "Total", [metric]: metricLabel };

    const query = useReport(
        api,
        accountID,
        showID,
        report,
        period,
        start,
        end,
        linkWindow,
        filters
    );

    const { data: periods } = usePeriods(
        api,
        report,
        accountID,
        showID,
        period,
        start,
        end,
        linkWindow,
        filters
    );

    // TODO: selected item chart data
    const chartData = periods?.results;

    return {
        query,
        report,
        id,
        api,
        accountID,
        showID,
        start,
        end,
        period,
        linkWindow,
        chartData,
        metric,
        labels,
    };
}
